/**
 * sessionStorage 工具类，封装 sessionStorage 的常用操作方法
 * @author 周亮
 * @createDate 2022-08-05
 */
class SessionStorage {

	static set(key, data) {
		let promise = new Promise(function(resolve, reject) {
			const item = typeof data === 'object' ? JSON.stringify(data) : data
			try {
				if (window.sessionStorage) { 
					window.sessionStorage[key] = item
					resolve()
				} else {
					reject('不支持 sessionStorage！')
				}
			} catch (e) {
				reject(e)
			}
		})
		return promise
	}

	static get(key) {
		let that = this
		let promise = new Promise(function(resolve, reject) {
			if (that.has(key)) {
				try {
					if (window.sessionStorage) {
						let data = JSON.parse(window.sessionStorage[key])
						resolve(data)
					} else {
						reject('不支持 sessionStorage！')
					}
				} catch (e) {
					reject(e)
				}
			} else {
				resolve(null)
			}
		})
		return promise
	}

	static remove(key) {
		let promise = new Promise(function(resolve, reject) {
			try {
				if (window.sessionStorage && window.sessionStorage[key]) {
					window.sessionStorage.removeItem(name)
					resolve()
				} else {
					reject('不支持 sessionStorage！')
				}
			} catch (e) {
				reject(e)
			}
		})
		return promise
	}

	static clear() {
		let promise = new Promise(function(resolve, reject) {
			try {
				try {
					if (window.sessionStorage) {
						window.sessionStorage.clear()
						resolve()
					} else {
						reject('不支持 sessionStorage！')
					}
				} catch (e) {
					reject(e)
				}
			} catch (e) {
				reject(e)
			}
		})
		return promise

	}

	static has(key) {
		let isContain = false
		try {
			if (window.sessionStorage && window.sessionStorage[key]) {
				isContain = true
			} else {
				return false
			}
		} catch (e) {
			return false
		}
		return isContain
	}

}

export default SessionStorage
